export const extractParamsAsMap = (
  searchParams: URLSearchParams
): Map<string, string[]> => {
  const map = new Map<string, string[]>();

  searchParams.forEach((value, key) => {
    const existing = map.get(key);
    if (existing) {
      existing.push(value);
    } else {
      map.set(key, [value]);
    }
  });

  return map;
};
